export default __webpack_public_path__ + "598c9a0cb091614b60ca3fb91a2c97f3.svg";